module.exports = __webpack_public_path__ + "files/SPIADI - Synthèse des recommandations - midline avec PI.ce6c78e324ae61489812d5174d65e16b.pdf";